module.exports = __webpack_public_path__ + "img/icon_bg_step_3.4ea7f0af.svg";